import RegisterAudit from './src/main';

/* istanbul ignore next */
RegisterAudit.install = function(Vue) {
  Vue.component(RegisterAudit.name, RegisterAudit);
};

export default RegisterAudit;
